module.exports = __webpack_public_path__ + "img/home.869cd79a.svg";